import TagsList from './TagsList';

export default TagsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/TagsList/index.js